import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { HEADER_TITLES } from 'shared/consts';
import { useCommonSlice, useMedia } from 'shared/hooks';
import { EMainRoutes } from 'shared/typings';

export const useHeader = (isPublisher?: boolean) => {
	const isMobile = useMedia();
	const isDesktop = useMedia('desktop');
	const location = useLocation();
	const { t } = useTranslation();
	const { headerTitle, setHeaderTitle } = useCommonSlice();
	useEffect(() => {
		const locationKeyArr = location.pathname
			.split(`${isPublisher ? EMainRoutes.PUBLISHER : EMainRoutes.ADVERTISER}/`)[1]
			?.split('/')
			?.slice(0, 3);

		if (locationKeyArr[0] === EMainRoutes.OFFER) {
			locationKeyArr.length == 2 && locationKeyArr[1] === EMainRoutes.CREATE
				? setHeaderTitle(
						HEADER_TITLES.find(({ key }) => `${EMainRoutes.OFFER}-${EMainRoutes.CREATE}` == key)?.title || '',
					)
				: setHeaderTitle(HEADER_TITLES.find(({ key }) => EMainRoutes.OFFER == key)?.title || '');
			locationKeyArr.length == 3 &&
				setHeaderTitle(HEADER_TITLES.find(({ key }) => `${EMainRoutes.OFFER}-${EMainRoutes.EDIT}` == key)?.title || '');
			return;
		}
		const locationKey = locationKeyArr.join('-');
		setHeaderTitle(HEADER_TITLES.find((item) => item.key === locationKey)?.title || '');
	}, [location]); //eslint-disable-line

	return {
		t,
		isMobile,
		isDesktop,
		headerTitle,
	};
};
